<template>
    <svg class="icon-avatar" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,0a6,6,0,1,0,6,6A6,6,0,0,0,12,0Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,12,10Z"/><path d="M12,13.5c-4,0-12,2-12,6V24H24V19.5C24,15.51,16,13.5,12,13.5ZM22,22H2V19.5c0-.83,1.24-1.84,3.24-2.64A20.11,20.11,0,0,1,12,15.5a20.11,20.11,0,0,1,6.76,1.36c2,.8,3.24,1.81,3.24,2.64Z"/></svg>
</template>
